import {Injectable} from '@angular/core';
import {AuthService} from './auth.service';
import {HttpClientWrapperService} from '../config/http-client-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class PetService {

  constructor(private authService: AuthService,
              private http: HttpClientWrapperService) {
  }

  getOffers() {
    return this.http.get('pet/statistics/offers');
  }

  getRequestInfo(requestID: number) {
    return this.http.get(`pet/statistics/details/${requestID}`, this.authService.decode().auth);
  }

  getAvailableVisitTypes(requestID: number) {
    return this.http.get(`pet/statistics/${requestID}/getAvailableVisitTypes`, this.authService.decode().auth);
  }

  submitVisitType(requestID: number, visitType: string) {
    return this.http.get(`pet/insurance/${requestID}/select-visit-type/${visitType}`, this.authService.decode().auth);
  }

  getAvailableReservation(requestID: number, weekCount: number) {
    return this.http.get(`pet/statistics/${requestID}/getAvailableVisitTypes/${weekCount}`, this.authService.decode().auth);
  }

  bookReservation(data: {
    requestID: number, clinicID: number, recordDate: number
  }) {
    return this.http.post(`pet/insurance/book-reservation/${data.requestID}`, data, this.authService.decode().auth);
  }
}
